"use client";
import s from "styled-components";
import t from "react";
import m from "./index.es366.js";
import d from "./index.es367.js";
import c from "./index.es368.js";
const b = s.div`
  display: flex;
  justify-content: flex-end;
  .tab {
    display: flex;
    align-items: center;

    & > button {
      display: flex;
      align-items: center;
      border: none;
      border-right: 0.09375rem solid #000;
      padding-right: 0.5rem;
      font-weight: 400;

      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
      &[aria-selected='true'] {
        font-weight: 700;
        &:hover {
          cursor: default;
          text-decoration: none;
        }
      }

      & > span {
        margin-left: 0.25rem;
      }
    }

    & > * {
      margin-left: 0.25rem;
    }

    &:last-child > button {
      border-right: none;
    }
  }
`, g = {
  line: /* @__PURE__ */ t.createElement(c, null),
  bar: /* @__PURE__ */ t.createElement(d, null),
  table: /* @__PURE__ */ t.createElement(m, null)
}, u = {
  line: "Linje",
  bar: "Søyler",
  table: "Tabell"
}, f = {
  line: "Visualisering av data som linjer. Data er også tilgjengelig i tabell",
  bar: "Visualisering av data som søyler. Data er også tilgjengelig i tabell",
  table: "Tabell visning av utvalgte data"
}, E = ({
  viewMode: l,
  viewModeChoices: a,
  blockId: r,
  onChange: i
}) => {
  const n = (e) => (o) => {
    o.preventDefault(), e !== l && i(e);
  };
  return /* @__PURE__ */ t.createElement(b, { role: "tablist" }, a.map((e) => /* @__PURE__ */ t.createElement("div", { className: "tab", key: `${r}-view-mode-choice--${e}` }, /* @__PURE__ */ t.createElement(
    "button",
    {
      className: "bl-link bl-size-5",
      role: "tab",
      "aria-label": f[e],
      "aria-selected": `${l === e}`,
      onClick: n(e)
    },
    g[e],
    /* @__PURE__ */ t.createElement("span", null, u[e])
  ))));
};
export {
  E as default
};
//# sourceMappingURL=index.es280.js.map
